var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23813 12.159C9.87563 13.7974 11.9498 14.8407 13.184 13.6124L13.4831 13.3132C13.8823 12.9149 13.8265 12.2549 13.3631 11.9332C13.0715 11.7299 12.7581 11.5115 12.4115 11.2682C12.0531 11.0165 11.5615 11.0557 11.2506 11.364L10.9123 11.6999C10.4931 11.434 10.0781 11.0932 9.69312 10.7082L9.69146 10.7065C9.30646 10.3215 8.96562 9.90653 8.69979 9.48737L9.03562 9.14903C9.34479 8.8382 9.38313 8.34653 9.13146 7.9882C8.88729 7.64153 8.66896 7.3282 8.46646 7.03653C8.14479 6.57403 7.48479 6.5182 7.08646 6.91653L6.78729 7.2157C5.55896 8.44987 6.60229 10.5232 8.23979 12.1615M15.1698 5.20153C13.7981 3.82903 11.974 3.07237 10.0306 3.07153C6.02479 3.07153 2.76563 6.32903 2.76479 10.3332C2.76313 11.6074 3.09729 12.8599 3.73396 13.964L2.70312 17.7274L6.55479 16.7174C7.62063 17.2974 8.81396 17.6015 10.0273 17.6015H10.0306C14.0348 17.6015 17.294 14.3432 17.2956 10.339C17.2965 8.39903 16.5415 6.57487 15.1698 5.20153Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    fill: "none",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.8586a92f.svg";
export { ForwardRef as ReactComponent };